<template>
  <div class="DeleteLyricPopup">
    <h2 class="font-size-middle">Czy na pewno chcesz usunąć piosenkę?</h2>
    <h2 class="font-size-middle">Piosenka zostanie usunięta także z playlist.</h2>
    <button class="delete-button  font-size-small"
            @click="$emit('delete')">Usuń
    </button>
    <button class="cancel-button font-size-small"
            @click="$emit('cancel')">Anuluj
    </button>
  </div>
</template>

<script>
export default {
  name: 'DeleteLyricPopup'
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.DeleteLyricPopup {
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 150px;
  border: 2px solid red;
  border-radius: 5px;
  margin: auto;
  padding: 20px 30px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: rgb(0, 0, 0);

  @media only screen and (max-width: 500px) {
    width: 300px;
    padding: 10px 20px;
  }

  h2 {
    color: white;
    font-weight: normal;
    text-align: center;
  }

  .cancel-button {
    position: absolute;
    bottom: 25px;
    right: 30px;
    min-width: 100px;
    height: 25px;
    background-color: transparent;
    color: white;
    border-color: white;
    border-radius: 6px;
    margin: 0 0 0 20px;
    cursor: pointer;
  }

  .delete-button {
    position: absolute;
    bottom: 25px;
    right: 150px;
    min-width: 100px;
    height: 25px;
    background-color: transparent;
    color: white;
    border-color: red;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
